import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Qué seguros ofrece OperaSafe.cl?",
    a: "Trabajamos 9 líneas pensadas para empresas industriales: maquinaria, equipos (industriales y electrónicos), plantas e instalaciones, ingeniería y montaje, flotas de vehículos, transporte de carga, responsabilidad civil, colaboradores (accidentes personales y autos a precio flota) y garantías (fiel cumplimiento, seriedad de la oferta, anticipos y correcta ejecución de las obras).",
  },
  {
    q: "¿Qué es el seguro Todo Riesgo Industrial?",
    a: "Es la póliza base de una planta o bodega: cubre el edificio, la maquinaria fija, las instalaciones, el contenido y las existencias frente a incendio, explosión, sismo, daño por agua, viento, inundación, robo con fuerza y daño malicioso, entre otros. Se complementa con remoción de escombros y honorarios profesionales.",
  },
  {
    q: "¿Qué cubre el seguro de avería de maquinaria?",
    a: "Cubre la rotura súbita e imprevista de tus máquinas: fuerza centrífuga, cortocircuito y sobretensión, defectos de material o montaje, falta de agua en calderas e incluso el error de operación del propio personal. También contempla repuestos y fletes de urgencia para volver a producir antes.",
  },
  {
    q: "¿Qué es el perjuicio por paralización?",
    a: "Es la cobertura de lucro cesante: cuando un siniestro detiene la operación, repone la utilidad bruta que dejas de generar y los gastos fijos que siguen corriendo (remuneraciones, arriendos, contratos), además de los gastos extraordinarios para reanudar la producción lo antes posible.",
  },
  {
    q: "¿Aseguran maquinaria y equipos móviles fuera de la faena?",
    a: "Sí. La póliza de equipos móviles y maquinaria pesada (TREC) cubre grúas, cargadores, grúas horquilla y equipos de contratistas dentro y fuera de faena, incluido el traslado entre obras, con daños físicos, volcamiento, robo, incendio y responsabilidad civil de operación como cobertura opcional.",
  },
  {
    q: "¿Qué significa “autos a precio flota para los colaboradores”?",
    a: "Es un beneficio para tu equipo: negociamos con la aseguradora para que los autos particulares de tus colaboradores accedan a la misma tarifa preferente de una flota de empresa, con hasta 60% de ahorro. Cada colaborador contrata su póliza individual y la empresa no asume ningún costo.",
  },
  {
    q: "¿Qué cubre la Responsabilidad Civil de una empresa industrial?",
    a: "Responde por los daños corporales o materiales que tu operación cause a terceros. Incluye RC general, RC patronal frente a tus propios trabajadores, RC de productos, RC cruzada entre contratistas y los gastos de defensa judicial.",
  },
  {
    q: "¿Qué son las garantías o pólizas de fiel cumplimiento?",
    a: "Son las garantías que reemplazan a la boleta bancaria: fiel cumplimiento de contrato, seriedad de la oferta, devolución de anticipos, correcta ejecución de las obras y obligaciones laborales y previsionales. Te permiten participar en licitaciones públicas y privadas sin inmovilizar tu línea de crédito.",
  },
  {
    q: "¿Pueden modificar el seguro que ya tengo o diseñar uno a medida?",
    a: "Sí. Podemos revisar y modificar tus pólizas vigentes para cerrar vacíos de cobertura, o diseñar coberturas completamente a medida según la necesidad de tu empresa, trabajando con las principales aseguradoras del país y con reaseguradores internacionales para riesgos grandes o poco comunes.",
  },
  {
    q: "¿Cuánto demora recibir mi propuesta?",
    a: "Apenas completas el formulario, uno de nuestros ejecutivos te contacta rápidamente con una propuesta clara, comparando entre las principales aseguradoras del país.",
  },
  {
    q: "¿Puedo mantener mi aseguradora actual?",
    a: "Sí. Trabajamos con BCI Seguros, SURA, Zurich, Reale, HDI, MAPFRE y Renta Nacional, por lo que buscamos la mejor alternativa, incluso con tu aseguradora actual si así lo prefieres.",
  },
  {
    q: "¿Tiene algún costo cotizar?",
    a: "No. Cotizar es totalmente gratis y sin compromiso. Solo pagas la prima de la póliza si decides contratar tu seguro con nosotros.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="scroll-mt-24 py-12 sm:scroll-mt-28 sm:py-16 bg-gray-50/60 border-t border-gray-100">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-gold">
            <HelpCircle className="h-4 w-4" /> Preguntas frecuentes
          </p>
          <h2 className="font-display mt-3 text-3xl sm:text-5xl font-bold tracking-tight text-brand-ink">
            Resolvemos tus dudas.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-gray-200">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-base sm:text-lg font-semibold text-brand-ink hover:no-underline py-5 text-left"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-600 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
